import { EventBroker } from "../../../lib/utils/event-broker";

export const EVENTS = {
  INIT: 'INIT'
}

export const copyToLayoutEventBroker = new EventBroker();
